import React from 'react';
import * as Styles from './styles';
import { SnappyAnimation } from './SnappyAnimation/SnappyAnimation';
import { withI18n } from 'react-i18next';

const LoaderPage = ({
  t, progress = 0, title = t('loaderPage.title'), borderRadius = 0,
}) => (
  <Styles.Wrapper borderRadius={borderRadius} data-testid="loader-page-wrapper">
    <Styles.LoaderWrapper>
      <SnappyAnimation />

      <Styles.ProgressBarContainer>
        <Styles.Progress percentage={progress} />
      </Styles.ProgressBarContainer>
    </Styles.LoaderWrapper>

    <Styles.LoaderText>{title}</Styles.LoaderText>
  </Styles.Wrapper>
);


export default withI18n()(LoaderPage);
